$(function() {
  var loggedInStatus = $('.faq-container').attr('data-status');
  var headerHt = $('.page-faqPage header .navbar').outerHeight();
  var headerHeight = headerHt;
  var sidebarStickyHeight = 245;
  //changes for IE11
  if (/Trident\/7\./.test(navigator.userAgent)) {
    $('.page-faqPage .faq-left-panel')
      .removeClass('faq-left-panel--sticky')
      .addClass('faq-left-panel--fixed');
    $('.page-faqPage .faq-right-panel').addClass('faq-right-panel--fixed');
    $('.page-faqPage .faq-container .faq-right-panel__title div').addClass(
      'faq-right-panel__title--fixed'
    );
  }

  $(window).scroll(function() {
    if (
      /Trident\/7\./.test(navigator.userAgent) &&
      $('.page-faqPage').length > 0
    ) {
      // Distance from top of document to top of footer.
      topOfFooter = $('footer').position().top;
      // Distance user has scrolled from top, adjusted to take in height of sidebar.
      scrollDistanceFromTopOfDoc =
        $(document).scrollTop() +
        $('.faq-left-panel').outerHeight() +
        40 +
        $('.faq-left-panel').position().top;
      // Difference between the two.
      scrollDistanceFromTopOfFooter = scrollDistanceFromTopOfDoc - topOfFooter;

      // If user has scrolled further than footer,
      // pull sidebar up using a negative margin.
      if (scrollDistanceFromTopOfDoc > topOfFooter) {
        $('.faq-left-panel').css(
          'margin-top',
          0 - scrollDistanceFromTopOfFooter
        );
      } else {
        $('.faq-left-panel').css('margin-top', 0);
      }
    }
  });
  function imageToggle() {
    var toggleImg = $(this).find('.faq-right-panel-question-toggle__img');
    if (toggleImg.hasClass('svg-icon_circle_plus_blue')) {
      toggleImg
        .removeClass('svg-icon_circle_plus_blue svg-icon_circle_plus_blue-dims')
        .addClass('svg-icon_circle_minus_blue svg-icon_circle_minus_blue-dims')
        .attr('alt', 'Minimize Icon');
    } else {
      toggleImg
        .removeClass(
          'svg-icon_circle_minus_blue svg-icon_circle_minus_blue-dims'
        )
        .addClass('svg-icon_circle_plus_blue svg-icon_circle_plus_blue-dims')
        .attr('alt', 'Maximize Icon');
    }
  }

  function signUpForAnAccount() {
    $('.header-signin')[0].click();
  }

  function loadEventListener() {
    if (loggedInStatus === 'False') {
      const faqSelectors = $(
        '.faq-right-panel__answer--upload,.faq-right-panel__answer-signIn'
      );
      faqSelectors.on('click', signUpForAnAccount);
      faqSelectors.attr('tabindex', 0).attr('role', 'button');
    } else if (loggedInStatus === 'True') {
      //Populate with Link to My Documents page
      $('.faq-right-panel__answer--upload').attr('href', '');
      $('.faq-right-panel__answer--acct').attr('href', '/my-account-home/page');
      //For ordering section populate with homepage redirection
      $('.faq-right-panel__answer-signIn').attr('href', '/');
    }
  }

  function scrollToSection(event) {
    event.preventDefault();
    $($(this).attr('href'))[0].scrollIntoView();
    scrollBy(0, -headerHeight);
  }
  $('#faqSidebar li a').on('click', scrollToSection);

  $('.faq-right-panel__question-toggle').on('click', imageToggle);
  $('body').scrollspy({
    target: '#faqSidebar',
    offset: sidebarStickyHeight
  });
  var previousLink = $('#faqSidebar li.active').index();
  $('body').on('activate.bs.scrollspy', function(event) {
    //changes for IE11
    if (/Trident\/7\./.test(navigator.userAgent)) {
      var linkActive = $(event.target).index();
      if (linkActive === 0 && previousLink === 0) {
        $('.page-faqPage .faq-left-panel').css('top', '40px');
      } else if (linkActive === 0 && previousLink > 0) {
        $('.page-faqPage .faq-left-panel').css('top', '');
      }
      previousLink = linkActive;
    }
  });
  loadEventListener();
});
